//#region src/date-picker/utils/set-date-till.ts
var e = (e) => (e.setHours(23, 59, 59, 999), e);
//#endregion
export { e as setDateTill };
